import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class WfUserContainerQueryCriteriaClass extends BaseCriteriaModel {
  // hdr
  user_type?: Optional<string> = Optional.empty();
  username?: Optional<string> = Optional.empty();
  login_subject?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  created_date_from?: Optional<string> = Optional.empty();
  created_date_to?: Optional<string> = Optional.empty();

  //ext
  hdr_guid?: Optional<string> = Optional.empty();
  line_guid?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_file?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
}

export class WfUserContainerCriteriaModelQuery {
  query = '';

  constructor(wfUserContainerCriteriaModel: WfUserContainerQueryCriteriaClass) {

    if (!wfUserContainerCriteriaModel) {
      return;
    }

    this.query += wfUserContainerCriteriaModel.user_type.filter(x => x !== '').map(x => '&user_type=' + x).orElse('');
    this.query += wfUserContainerCriteriaModel.username.filter(x => x !== '').map(x => '&username=' + x).orElse('');
    this.query += wfUserContainerCriteriaModel.login_subject.filter(x => x !== '').map(x => '&login_subject=' + x).orElse('');
    this.query += wfUserContainerCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += wfUserContainerCriteriaModel.created_date_from.filter(x => x !== '').map(x => '&created_date_from=' + x).orElse('');
    this.query += wfUserContainerCriteriaModel.created_date_to.filter(x => x !== '').map(x => '&created_date_to=' + x).orElse('');

    this.query += wfUserContainerCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += wfUserContainerCriteriaModel.line_guid.filter(x => x !== '').map(x => '&line_guid=' + x).orElse('');
    this.query += wfUserContainerCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += wfUserContainerCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += wfUserContainerCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += wfUserContainerCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += wfUserContainerCriteriaModel.value_file.filter(x => x !== '').map(x => '&value_file=' + x).orElse('');
    this.query += wfUserContainerCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');

    this.query += '&status=' + wfUserContainerCriteriaModel.status;
    this.query += '&orderBy=' + wfUserContainerCriteriaModel.orderBy;
    this.query += '&order=' + wfUserContainerCriteriaModel.order;
    this.query += '&offset=' + wfUserContainerCriteriaModel.offset + '&limit=' + wfUserContainerCriteriaModel.limit;
  }
}
